"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createContext, useCallback, useMemo, useReducer, useRef } from 'react';
import { loadState, saveState } from '../utils';
import { providerFactory } from './providerFactory';
export const createAction = (type, payload) => ({
  type,
  payload
});
export const useDistributedState = ({
  initialState,
  reducer,
  channelName,
  userId,
  storageType
}) => {
  const channelRef = useRef(new BroadcastChannel(`${userId}-${channelName}`));
  const [state, dispatchAction] = useReducer(
  // @ts-ignore
  reducer, loadState({
    key: channelName,
    uniqueId: userId,
    storageType
  }) || initialState);
  const initialisedRef = useRef(false);
  const updateState = useCallback((newState, onDone) => {
    const action = createAction('UPDATE_STATE', newState);
    if (JSON.stringify(newState) === JSON.stringify(state)) {
      return;
    }
    dispatchAction(action);
    channelRef.current.postMessage(action);
    saveState({
      key: channelName,
      uniqueId: userId,
      state: newState,
      storageType
    });
    // Check if onDone is a function
    if (typeof onDone === 'function') {
      // Use requestIdleCallback to call onDone when the browser is idle
      window.requestIdleCallback(() => {
        onDone(newState);
      });
    }
  }, [dispatchAction, state]);
  const stateContext = /*#__PURE__*/createContext({
    state: initialState,
    updateState
  });
  const Provider = useMemo(() => providerFactory({
    stateContext,
    // @ts-ignore
    state,
    updateState,
    channelRef,
    userId,
    channelName,
    storageType,
    dispatchAction,
    initialisedRef
  }), [stateContext, state, updateState, channelRef, userId, channelName, storageType, dispatchAction, initialisedRef]);
  const cleanup = () => {
    saveState({
      key: channelName,
      uniqueId: userId,
      state: null,
      storageType
    });
    const channel = new BroadcastChannel(`${userId}-${channelName}`);
    channel.close();
  };
  return {
    stateContext,
    dispatchAction,
    Provider,
    cleanup
  };
};